module.exports = __webpack_public_path__ + "img/96beac6.webp";